import { render, staticRenderFns } from "./ShadowCompany.vue?vue&type=template&id=c82d9050&"
import script from "./ShadowCompany.vue?vue&type=script&lang=js&"
export * from "./ShadowCompany.vue?vue&type=script&lang=js&"
import style0 from "./ShadowCompany.vue?vue&type=style&index=0&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports